import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { useNavigate } from "react-router-dom";
import { fetchstaff, fetchstaffdata, statusupdate } from '../../../api/FacultyService'
import Swal from "sweetalert2";
import { formatDate, ToastMain,SweetAlertShow } from "../../master/Master";
import DownloadExcel from "../../master/DownloadExcel";
import { getSessions } from "../../../api/SessionsService";
export default function Teacher() {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();
  const [EditFormData, setEditFormData] = React.useState("");
  const [SelectedStaffId, setSelectedStaffId] = React.useState("");
  const [Staff, setStaff] = React.useState("");
  const [Result, setResult] = React.useState("");
  const [teachers, setTeachers] = React.useState("");
  const [Batches, setBatches] = React.useState("");
  const [SelectedId, setSelectedId] = React.useState("");
  const [Active, setActive] = useState('');
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false); // for loading state
  const [selectedType, setSelectedType] = useState(null); // default to all
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSessions] = useState('');

  const getSession = async () => {
    try {
      const response = await getSessions(); // <-- your API call
      if (response?.data?.status) {
        // const activeSessions = response?.data?.data?.filter(
        //   (session) => session?.status === "1"
        //);

        setSessions(response?.data?.data);
        // setSessions(activeSessions);

      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (err) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: err?.response?.data?.message || 'something went wrong'
      // })

      SweetAlertShow('error','Error',err?.response?.data?.message ?? err?.message)
    }
  };
  useEffect(() => {
    getSession();

  }, [])

  useEffect(() => {
    if (sessions?.length > 0 && !selectedSession) {
      let sesions_id = sessions?.find((s) => s.status == '1')?.id ?? null;
      setSelectedSessions(sesions_id);
    }
  }, [sessions]);



  const statusMap = {
    0: "Inactive ",
    1: " Active",


  };
  const handleAddStaff = () => {
    navigate("/teachers/add"); // ✅ Replace with your actual route
  };

 const staffFatch = async () => {
  let addUrl = `&session_id=${selectedSession}&type=${selectedType || ''}`;
  try {
    const response = await fetchstaffdata(addUrl);

    if (response.data.status) {
      // ✅ actual staff list `response.data.data.data` me hai
      setTeachers(response.data.data?.data || []);
    } else {
      // ToastMain.fire({
      //   icon: "info",
      //   title: response?.data?.message || "something went wrong",
      // });

      SweetAlertShow('info','Warning',response?.data?.message )
    }
  } catch (err) {
    // ToastMain.fire({
    //   icon: "error",
    //   title: err?.response?.data?.message || "something went wrong",
    // });

    SweetAlertShow('error','Error', err?.response?.data?.message  ?? err?.message)
  }
};



  useEffect(() => {
    staffFatch(); // ⏳ Fetch on component load
  }, [selectedSession , selectedType]);





  const handlestaffstatus = async (e) => {
    e.preventDefault();
    setLoading(true); // 🌀 Show loading spinner
    try {
      const formData = new FormData(e.target);
      const data = Object.fromEntries(formData.entries());

      const response = await statusupdate(data);
      console.log(response)
      if (response.data) {
        setResult(" " + response.data.message);
        console.log(" Status Update:", response);

        ToastMain.fire({
          icon: "success",
          title: "updated successfully!",
        });
        staffFatch();
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (err) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: err?.response?.data?.message || 'something went wrong'
      // })
      SweetAlertShow('error','Error',err?.response?.data?.message ?? err?.message)

    } finally {
      setLoading(false);
    }
    // 🌀 Hide loading spinner
  };
  // 🔁 Utility: Get batch titles by teacher.batches (IDs)
  const getBatchTitles = (batchIds = []) => {

    if (!Array.isArray(batchIds)) return "";
    const related = Batches.filter(batch => batchIds.includes(batch.id));
    return related.map(b => b.title).join(", ");
  };

  const handleDownload = () => {
    const exportData = teachers;

    if (!Array.isArray(exportData) || exportData.length === 0) {
      alert("No staff data available to export");
      return;
    }

    // Map staff data for Excel export
    const staffExport = exportData.map((staff, index) => ({
      SN: index + 1,
      "Staff Name": staff?.name || "N/A",
      "Staff Type": staff?.type_id || "N/A",
      "Phone": staff?.phone || "N/A",
      "Secondary Phone": staff?.secondary_phone || "N/A",
      "Gender": staff?.gender || "N/A",
      "Date of Birth": formatDate(staff?.dob) || "N/A",
      "Education": staff?.education || "N/A",
      "School": staff?.school || "N/A",
      "Village": staff?.village || "N/A",
      "District": staff?.district || "N/A",
      "State": staff?.state || "N/A",
      "Salary": staff?.present_salary || 0,
      "Status": staff?.status === "1" ? "Active" : "Inactive",
      "Remark": staff?.remark || "N/A"
    }));

    // Download Excel
    DownloadExcel(
      staffExport,
      [
        "SN",
        "Staff Name",
        "Staff Type",
        "Phone",
        "Secondary Phone",
        "Gender",
        "Date of Birth",
        "Education",
        "School",
        "Village",
        "Tehsil",
        "District",
        "State",
        "Salary",
        "Status",
        "Remark"
      ],
      "Staff_List_Report"
    );
  };
return (
    <>

      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="container-fluid flex-grow-1 container-p-y">
                  <div className="card p-3 mb-4 ">
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">

                      <h4 className="text-primary fw-bold mb-0">Faculty</h4>

                      {/* Right: Add button + input */}
                      <div
                        className="d-flex align-items-center gap-2"

                      >
                        {hasAccess('/add/staff') && (
                          <button
                            className="btn btn-primary text-white w-100"
                            onClick={handleAddStaff}
                          >
                            <i className="bi bi-plus-circle me-2"></i>
                            Add New
                          </button>
                        )}

                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                      <div className="col-md-5 form-floating form-floating-outline">
                          <select className="form-select" name="session" value={selectedSession} onChange={(e) => setSelectedSessions(e.target.value)}>
                            {/* <option value="">Select Session</option> */}
                            {sessions?.map((session) => (
                              <option
                                key={session?.id}
                                value={session?.id}
                              >
                                {session?.session}:{session?.status == '1' ? 'Active' : ' Inactive'}
                                {/* Show "2023-24" */}
                              </option>
                            ))}
                          </select>

                          <label >
                            Filter Session
                          </label>
                        </div>
                      <div className="d-flex gap-2 flex-wrap">
                        
                        <button
                          className={`btn ${selectedType === null ? 'btn-primary' : 'btn-label-primary'} me-2`}
                          onClick={() => {
                            setSelectedType(null);   // "All" selected
                                      // No type sent => returns all teachers
                          }}
                        >
                          All
                        </button>
                        <button
                          className={`btn ${selectedType === 1 ? 'btn-primary' : 'btn-label-primary'} me-2`}
                          onClick={() => {
                            setSelectedType(1);
                             // Send type 1
                          }}
                        >
                          Active
                        </button>

                        <button
                          className={`btn ${selectedType === 2 ? 'btn-primary' : 'btn-label-primary'}`}
                          onClick={() => {
                            setSelectedType(2);
                             // Send type 2
                          }}
                        >
                          Inactive
                        </button>
                        {hasAccess('/export/staff') && (
                          <button
                            className="btn btn-success btn-sm"
                            onClick={handleDownload}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Export Excel"
                          >
                            <i className="bi bi-cloud-arrow-down ri-20px"></i>
                          </button>
                        )}

                      </div>
                    </div>
                    <table className="table table-hover text-center align-middle">
                      <thead className="table-label-primary">
                        <tr>
                          <th>#</th>
                          <th>Staff ID</th>
                          <th>Name</th>
                          <th>Mobile No</th>
                          <th>Father's Name</th>
                          <th>Joining Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>

                        {teachers.length > 0 ? (
                          teachers.map((teacher, index) => (
                            <tr key={teacher.id || 'N/A'}>
                              <td>{index + 1 || 'N/A'}</td>
                              <td>{teacher.id || 'N/A'}</td>
                              <td className="text-primary fw-semibold">{teacher.name || 'N/A'}</td>
                              <td>{teacher.phone || 'N/A'}</td>
                              <td>{teacher?.father_name || 'N/A'}</td>
                              <td>0</td>
                              <td>
                                {hasAccess('/staff/status/update') && (
                                  <span
                                    className={`badge cursor-pointer ${teacher?.status === '0'
                                      ? "bg-label-danger"
                                      : teacher?.status === '1'
                                        ? "bg-label-success"
                                        : "bg-label-secondary"
                                      }`}
                                    {...(hasAccess('/staff/status/update') && {
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#Active",
                                      onClick: () => setSelectedId(teacher?.id),
                                    })}
                                  >
                                    {statusMap[teacher?.status] || "Unknown"}
                                    <i className="bi bi-caret-right ms-1"></i>
                                  </span>
                                )}
                              </td>



                              <td>
                                <div className="demo-inline-spacing py-0 my-0">
                                  <div className="btn-group py-0 my-0" id="hover-dropdown-demo">
                                    <button
                                      type="button"
                                      className="btn dropdown-toggle py-0 my-0"
                                      data-bs-toggle="dropdown"
                                      data-trigger="hover"
                                      aria-expanded="false"
                                    >
                                      <i className="bi bi-three-dots-vertical" />
                                    </button>
                                    <ul className="dropdown-menu py-0">
                                      <li>
                                        {hasAccess('/teachers/view/:id') && (
                                          <button
                                            className="dropdown-item"
                                            onClick={() => navigate(`/teachers/view/${teacher?.id}`)}
                                          >
                                            <i className="bi bi-eye-fill me-2 text-success"></i> View
                                          </button>
                                        )}
                                      </li>
                                      <li>
                                        {/* <button
                                          className="dropdown-item"
                                          onClick={() => navigate("/teachers/batchtime")}
                                        >
                                          <i className="bi bi-info-circle me-2 text-info"></i> Teacher Info
                                        </button> */}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </td>

                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">No teachers found.</td>
                          </tr>
                        )}

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <Footer />
              <div className="content-backdrop fade"></div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
      {/* Createnewbatch modal  */}
      <div
        className="modal fade"
        id="TeacherInformation"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Teacher Information
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="container mt-4">
                <form>
                  <div className="mb-3">Name: test</div>
                  <div className="mb-3">Phone: 1234567890</div>

                  <div className="mb-3">
                    <label for="teacher" className="form-label">
                      Assign Test:
                    </label>
                    <select className="form-select" id="teacher">
                      <option value="2">weekly</option>
                      <option value="4">test</option>
                      <option value="8">PD. TEST (1)</option>
                      <option value="9">PD. TEST (1)</option>
                      <option value="12">PD. TEST 2</option>
                      <option value="13">PD. TEST 3</option>
                      <option value="14">HALF YEARLY</option>
                      <option value="15">YEARLY EXAM</option>
                      <option value="22">1test</option>
                      <option value="23">2test</option>
                      <option value="24">3test</option>
                      <option value="25">haaf</option>
                      <option value="26">year</option>
                      <option value="29">TEST 1</option>
                      <option value="30">TEST 2</option>
                      <option value="31">TEST 3</option>
                      <option value="32">HALF YEARLY</option>
                      <option value="33">YEARLY</option>
                      <option value="34">TEST 1</option>
                      <option value="36">TEST 3</option>
                      <option value="37">HALF YEARLY</option>
                      <option value="38">YEARLY EXAM</option>
                      <option value="41">TEST 1 IV</option>
                      <option value="42">TEST 2 IV</option>
                      <option value="43">TEST 3 IV</option>
                      <option value="44">HALF YEARLY</option>
                      <option value="45">YEARLY EXAM IV</option>
                      <option value="47">IV TEST 1</option>
                      <option value="48">IV TEST 2</option>
                      <option value="49">IV TEST 3</option>
                      <option value="50">IV HALF YEARLY</option>
                      <option value="51">YEARLY EXAM</option>
                      <option value="58">HALF YEARLY II</option>
                      <option value="59">YEARLY II</option>
                      <option value="61">TEST 1 VII B</option>
                      <option value="62">TEST 2 VII B</option>
                      <option value="63">TEST 3 VII B</option>
                      <option value="64">HALF YEARLY VII B</option>
                      <option value="65">YEARLY EXAM VII B</option>
                      <option value="67">test 2 vi a</option>
                      <option value="69">TEST 1 III</option>
                      <option value="70">TEST 2 III</option>
                      <option value="71">TEST 3 III</option>
                      <option value="72">HALF YEARLY III</option>
                      <option value="73">YEARLY EXAM III</option>
                      <option value="78">VII A TEST 1</option>
                      <option value="79">
                        VII A TEST 2<option value="78">VII A TEST 1</option>
                      </option>
                      <option value="80">VII A TEST 3</option>
                      <option value="82">TEST 1</option>
                      <option value="83">TEST 2</option>
                      <option value="84">HALF YAERLY</option>
                      <option value="85">YEARLY EXAM</option>
                      <option value="89">HALF YEARLY I A</option>
                      <option value="90">YEARLY I A</option>
                      <option value="92">HALF YEARLY I B</option>
                      <option value="93">YEARLY I B</option>
                      <option value="95">HALF YEARLY UKG A</option>
                      <option value="96">YEARLY UKG. B</option>
                      <option value="102">HALF YEARLY LKG. I</option>
                      <option value="103">YEARLY LKG. A</option>
                      <option value="105">HALF YEARLY LKG B</option>
                      <option value="106">YAERLY LKG . B</option>
                      <option value="107">HALF YEARLY UKG. B</option>
                      <option value="108">YEARLY UKG . B</option>
                      <option value="109">HALF YEARLY VII A</option>
                      <option value="110">YEARLY VII A</option>
                      <option value="112">HALF YEARLY LKG B</option>
                      <option value="113">YEARLY LKG B</option>
                      <option value="114">TEST 3 MARK</option>
                      <option value="116">HALF YEARLY NUE A</option>
                      <option value="117">YEARLY NUR . A</option>
                      <option value="119">p s test</option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Editstatus modal */}
      <div
        className="modal fade"
        id="Active"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-label-primary p-3">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Status Update

              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form onSubmit={handlestaffstatus}>
                <input type="hidden" name="id" value={SelectedId} />

                <div className="mb-3" >

                  <select className="form-select  form-floating form-floating-outline  mb-1 fv-plugins-icon-container" name="status" required>
                    <option value="" disabled selected>Select Status</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>

                  </select>
                </div>

                {/* <div className="modal-footer p-4 bg-label-primary">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">Submit</button>
                </div> */}
                <div className="modal-footer  p-3">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">
                    Submit
                  </button>
                </div>
              </form>

            </div>

          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="pencli"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog ">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Edit Batch Details
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="container mt-4">
                <form>
                  <div className="mb-3">
                    <label htmlFor="course" className="form-label">
                      Select Course
                    </label>
                    <select
                      className="form-select"
                      id="course"
                      defaultValue="REMOVE STUDENTS"
                    >
                      <option>REMOVE STUDENTS</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="title" className="form-label">
                      Title
                    </label>
                    <input
                      type="text"
                      className="form-control input-capitalize"
                      id="title"
                      defaultValue="REMOVE BATCH"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="timing" className="form-label">
                      Batch Timing
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="timing"
                      defaultValue="11"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="regFees" className="form-label">
                      Batch Reg. Fees
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="regFees"
                      defaultValue="0"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="fees" className="form-label">
                      Batch Fees
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="fees"
                      defaultValue="0"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="teacher" className="form-label">
                      Batch/Class Teacher
                    </label>
                    <select
                      className="form-select"
                      id="teacher"
                      defaultValue="rohit (1)"
                    >
                      <option>rohit (1)</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="startDate" className="form-label">
                      Starting Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="startDate"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
